import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {BunkerProduct, ExemptionDebunkering, Vessel} from "@portbase/bezoekschip-service-typescriptmodels";
import {Observable, of} from "rxjs";
import {BunkeringService} from "../../../../../bunkering/bunkering.service";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-debunkering',
    templateUrl: './exemption_debunkering.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionDebunkeringComponent extends ExemptionBaseComponent {

  @Input() exemption: ExemptionDebunkering;

  vessel: Vessel;

  newReason = (value: string): string => value;
  newDestination = (value: string): string => value;

  searchReasons = (term: string): Observable<string[]> => of(["Sulphur content", "Catalytic fines (Ai + Si)", "Chemical contamination", "Water content",
  "Excessive quantity", "Sludge", "Final ships use before scrapping", "End of charter party", "Change of grade", "Filter blocking", "Letter of protest attached",
  "Unfit for use", "Dry-docking", "Analysis results"]
    .filter(value => !term || value.toLowerCase().includes(term.toLowerCase())));

  searchDestinations = (term: string): Observable<string[]> => of(["Refinery", "Storage terminal", "Waste reception facility"]
    .filter(value => !term || value.toLowerCase().includes(term.toLowerCase())));

  products(term: string): Observable<BunkerProduct[]> {
    return BunkeringService.products(term);
  }

  formatProduct(product: BunkerProduct) {
    return product.type + ' (' + product.provisionType + ') ' + ' (' + product.density + ') ' + product.unitOfMeasure;
  }

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  resetVesselInfo() {
    this.vessel = null;
    this.exemption.vesselENI = '';
    this.exemption.vesselIMO = '';
    this.exemption.vesselNameENI = '';
    this.exemption.vesselNameIMO = '';
  }
}

